// Form
(function () {
    const initLabel = (field) => {
        const input = field.querySelector(`.js-input`);

        input?.addEventListener(`focusout`, () => {
            if (input.value) {
                field.classList.add(`form__field--filled`);
            } else {
                field.classList.remove(`form__field--filled`);
            }
        });
    };

    const setPhoneMask = (input) => {
        return IMask(input, {
            mask: `+{7} (000) 000-00-00`,
            lazy: false,
            placeholderChar: `_`,
        });
    };

    window.form = {
        initLabel: initLabel,
        setPhoneMask: setPhoneMask,
    };
})();